import styled from "styled-components";
import { NavIcon } from "../NavMenu/navItems";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 56px 24px;
  text-align: center;
  border: 1px dashed ${(props) => props.theme.borderStrong};
  border-radius: 12px;
  color: ${(props) => props.theme.secondaryTextColor};
`;

const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: 6px;
  border-radius: 12px;
  background: ${(props) => props.theme.surfaceHover};
  color: ${(props) => props.theme.secondaryTextColor};

  svg {
    width: 22px;
    height: 22px;
  }
`;

const Title = styled.span`
  font-size: 14.5px;
  font-weight: 600;
  color: ${(props) => props.theme.textColor};
`;

const Description = styled.span`
  font-size: 13px;
  max-width: 420px;
`;

const EmptyState: React.FC<{
  Icon?: NavIcon;
  title: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}> = ({ Icon, title, description, className, style }) => {
  return (
    <Container className={className} style={style}>
      {Icon && (
        <IconWrap>
          <Icon />
        </IconWrap>
      )}
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
    </Container>
  );
};
export default EmptyState;
